import {v4 as uuidv4} from 'uuid';
import {getEnv} from '../../common/env/env';
import {MyNewsVo} from '../../common/shared/api/nicolas/vo/MyNewsVo.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {MyNewsItem} from '../generated/types';
import {createMyNewsType} from './MyNewsType';
import {createNotiType} from './NotiType';

export function createMyNewsItem({
  type,
  title,
  message,
  thumbnail,
  scheme,
  date,
  log_name,
  news_id,
  ad_loc_id,
}: MyNewsVo): MyNewsItem {
  return {
    id: uuidv4(),
    type: createMyNewsType(type),
    title,
    message,
    thumbnail: thumbnail
      ? thumbnail.startsWith('http')
        ? thumbnail
        : getKageUrl({
            kageUrlPrefix: getEnv().kageUrlPrefix,
            kageId: thumbnail,
            resolution: 'th3',
          })
      : undefined,
    scheme,
    date,
    logName: log_name ? createNotiType(log_name) : undefined,
    newsId: news_id,
    adLocId: ad_loc_id,
  };
}
